import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHourglassTop = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 13 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.84912 1L3.85412 4L5.84912 6L3.85412 8.005L3.84912 11H9.84912V8L7.84912 6L9.84912 4.005V1H3.84912ZM8.84912 8.25V10H4.84912V8.25L6.84912 6.25L8.84912 8.25Z",
		fill: "currentColor"
	})
});
export default SvgIconHourglassTop;
